import { gql } from "@apollo/client";

const CREATE_PROGRAMME_PREFILLED = gql`
  mutation createProgrammePrefilled($programmeFile: String, $baseUrl: String, $apiKey: String, $schacCode: String)
    {createProgrammePrefilled(programmeFile: $programmeFile, baseUrl: $baseUrl, apiKey: $apiKey, schacCode: $schacCode) {
      success
      errors {
        row
        path
        message
      }
      data
    }  
  }`
;

export default CREATE_PROGRAMME_PREFILLED;
